module.exports = __webpack_public_path__ + "static/media/provider-stand-subscribe.0b3edc53.svg";